module.exports = __webpack_public_path__ + "img/banner-1.3ff404e2.jpg";